<template>
    <nav class="navbar">
        <div class="container-fluid">
            <div class="d-flex align-items-center justify-content-between row no-gutters flex-grow-1">

                <div class="col-2">
                    <router-link to="/"><img src="@/assets/shiseido_logo_orange.svg" class="img-fluid logo"></router-link>
                </div>
                <div class="col-8 text-center">
                    <div class="navbar-toggler d-lg-none" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation"  v-on:click="openNav()">
                        <div class="navbar__indicator">
                            <ul>
                                <li class="sidebar__item-1 sidebar__item--active"><span v-html="$t('GLOBAL_MENU_01')">Introduction</span></li>
                                <li class="sidebar__item-2"><span v-html="$t('GLOBAL_MENU_02')">Key information</span></li>
                                <li class="sidebar__item-3"><span v-html="$t('GLOBAL_MENU_03')">How it works</span></li>
                                <li class="sidebar__item-4"><span v-html="$t('GLOBAL_MENU_04')">At the counter</span></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-2 text-right">
                    <img src="@/assets/icons/volume.svg" @click="toggleSound" v-if="soundPlaying" class="img-fluid sound">
                    <img src="@/assets/icons/volume-mute.svg" @click="toggleSound" v-else class="img-fluid sound">
                </div>
            </div>
        </div>

        <div class="collapse navbar-collapse" id="navbarNav">

            <div class="nav__item mt-4" v-on:click="closeNav(1)">
                <div class="nav__item--name" v-html="$t('GLOBAL_MENU_01')">Introduction</div>
            </div>
            <div class="nav__item" v-on:click="closeNav(3)">
                <div class="nav__item--name" v-html="$t('GLOBAL_MENU_02')">Key information</div>
            </div>
            <div class="nav__item" v-on:click="closeNav(4)">
                <div class="nav__item--name" v-html="$t('GLOBAL_MENU_03')">How it works</div>
            </div>
            <div class="nav__item" v-on:click="closeNav(5)">
                <div class="nav__item--name" v-html="$t('GLOBAL_MENU_04')">At the counter</div>
            </div>
            <div class="nav__item--close mt-3">
                <div class="btn__close d-flex align-items-center justify-content-center" >
                    <div class="btn__close-text mr-1 font-24 font-medium" v-html="$t('GLOBAL_CLOSE')">
                        close module
                    </div>
                    <div class="close__btn"><img src="@/assets/icons/times.svg"></div>
                </div>
            </div>
            <div class="navbar__close" v-on:click="closeNav(0)"><img src="@/assets/icons/close--white.svg"></div>

            <div class="bg"></div>
        </div>
    </nav>
</template>

<script>
    import { EventBus } from '@/main';
    import { gsap, TimelineMax, CSSPlugin } from 'gsap/all'

    gsap.registerPlugin(CSSPlugin)

    export default {
        name: "Navigation",
        components: {
            EventBus
        },
        data(){
            return {
                sites: "",
                timeline: '',
                sound: '',
                soundPlaying: false,
            }
        },
        methods: {
            getKapitel(kapitel){
                return "0"+kapitel;
            },
            toggleSound() {
                if (this.soundPlaying) {
                    this.sound.pause()
                } else {
                    this.sound.play();
                }
                this.soundPlaying = !this.soundPlaying;
            },
            pauseSound(keyword) {
                console.log(keyword, this.soundPlaying);
                if (this.soundPlaying) {
                    if (keyword == 'play') {
                        this.sound.play()
                    } else if (keyword == 'pause') {
                        this.sound.pause();
                    }
                }
            },
            openNav(){
                const trigger = document.querySelector('#navbarNav').classList
                if (trigger.contains('show')) {
                    //trigger.toggle('show')
                    this.timeline.reverse()
                } else {
                    trigger.add('show')
                    this.timeline.restart()
                }
            },
            closeNav(chapter){
                this.timeline.reverse()
                if (chapter > 0) {
                    EventBus.$emit('silentMoveToSection', [chapter]);
                }
            },
            reverseFunction() {
                document.querySelector('#navbarNav').classList.toggle('show');
            }
        },
        mounted() {
            this.timeline = new TimelineMax({onReverseComplete : function () {
                document.querySelector('#navbarNav').classList.toggle('show');
            }})
            this.timeline.from('.bg', 0.25, {yPercent: -100});
            this.timeline.staggerFrom('.nav__item', 0.25, {opacity: 0}, 0.2);
            this.timeline.from('.nav__item--close', 0.25, {opacity: 0});

            this.sound = new Audio('https://www.discover-shiseido.com/Module/Suncare-SS-2020/audio/beachwaves.mp3');

            EventBus.$on('pauseSound', keyword => {
                this.pauseSound(keyword)
            });
        },



    }
</script>

<style scoped>

</style>